import { z } from 'zod'
import { monosanFetch } from '@/shared/api/monosanFetch'
import { AuthError } from '@/shared/api/errors'
import { tokenStore } from '@/features/auth/model/tokenStore'
import { publicKeyStore } from '@/shared/crypto/publicKey'

const refreshResponseSchema = z.object({
  accessToken: z.string(),
  expiresIn: z.number(),
  publicKey: z.string(),
})

// The 401 (no/invalid session) body still carries the public key so the client
// can encrypt the next login without hardcoding it.
const publicKeyBodySchema = z.object({ publicKey: z.string() })

export const refresh = async (): Promise<void> => {
  try {
    const { accessToken, expiresIn, publicKey } = await monosanFetch(
      '/api/auth/refresh',
      {
        method: 'POST',
        schema: refreshResponseSchema,
        skipAuth: true,
        requiresCookie: true,
      }
    )
    publicKeyStore.set(publicKey)
    tokenStore.set({ accessToken, expiresAt: Date.now() + expiresIn * 1000 })
  } catch (err) {
    if (err instanceof AuthError) {
      const parsed = publicKeyBodySchema.safeParse(err.body)
      if (parsed.success) publicKeyStore.set(parsed.data.publicKey)
    }
    throw err
  }
}
